import { h } from "preact"

export const SelectionButtons = ({
  buttons,
  active,
  activate,
  activateAll = false,
}) => {
  return (
    <div class="button-selection">
      {buttons.map((button, idx) => (
        <Button {...{ button, active, activate, activateAll }} key={idx} />
      ))}
    </div>
  )
}

export const Button = ({ button, active, activate, activateAll }) => {
  const isActive = activateAll || active === button.id

  return (
    <button
      key={button.id}
      class={`button ${isActive && "active"}`}
      onClick={() => {
        activate(button.id, button.type)
      }}
    >
      <span>{button.title}</span>
    </button>
  )
}
